import { useLocalization } from '@lib/localization';
import { IconButton, Tooltip } from '@mui/material';
import { useLazyGetInspectionReportQuery, type IInspection } from '@store/api/inspectionEndpoints';
import { DownloadIcon } from 'lucide-react';
import { type MouseEvent } from 'react';

interface InspectionReportDownloadProps {
  inspection: IInspection;
  projectId: string;
  projectName: string;
}

export const InspectionReportDownload: React.FC<InspectionReportDownloadProps> = ({
  inspection, projectId, projectName }) => {
  const { t, currentLanguage } = useLocalization();
  const [fetchInspectionReport, { isFetching }] = useLazyGetInspectionReportQuery();

  const downloadReport = async (e: MouseEvent) => {
    try {
      e.stopPropagation();

      const inspectionReportData = await fetchInspectionReport({
        projectId,
        inspectionId: inspection.info.id,
        locale: currentLanguage
      });

      const inspectionReportUrl = inspectionReportData.data;

      if (!inspectionReportUrl) return;

      const link = document.createElement('a');
      link.href = inspectionReportUrl;
      link.download = `${projectName} - ${inspection.info.name}.pdf`;
      link.click();

      URL.revokeObjectURL(inspectionReportUrl);

    } catch (err) {
      console.error('Failed to download inspection report', err);
    }
  };

  return (
    <Tooltip title={t('Report_Download', ['(.pdf)'])}>
      <IconButton onClick={downloadReport} disabled={isFetching}>
        <DownloadIcon />
      </IconButton>
    </Tooltip>
  );
};
